/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).on("click", ".js-cart-terms-input", function() {
  const isChecked = $(this).is(":checked");
  
  if (isChecked) {
    $(".cart__checkout").removeAttr("disabled");
  } else {
    $(".cart__checkout").attr("disabled", "disabled");
  }
});
